<template>
  <div>
    <my-table :title="title"
              :searchParams="searchParams"
              :isAdd="isAdd"
              :tableData="tableData"
              @pageNumChange="pageNumChange"
              @search="search"
              @keyup.enter.native="keyup()" @add="addMerchants">
      <div slot="table">
        <merchants-table :tableData="tableData.list" @del="del"></merchants-table>
      </div>
    </my-table>
  </div>
</template>

<script>
  import MerchantsTable from "./CoveShedTable";
  import MyTable from "../../components/content/myTable/MyTable";
  import {getCoveShedList,newVue,delByCoveShedId} from "../../network/coveShed";

  export default {
    name: "CoveShedList",
    components: {MerchantsTable, MyTable},
    data(){
      return {
        title: "心坞栈列表",
        //搜索条件
        searchParams:[
          {
            key:"coveShedClassify",
            value:"心坞栈类型"
          },
          {
            key:"coveShedName",
            value:"心坞栈名称"
          },
          {
            key:"coveShedUsername",
            value:"联系人名称"
          },
          {
            key:"detailAddress",
            value:"心坞栈区域"
          }

        ],
        isAdd: true,
        tableData:{},
        searchItems:{}
      }
    },
    created() {
      newVue.obj = this;
      this.common.HeaderLocationTwo.href =  "/coveShed/list";
      this.common.HeaderLocationTwo.name = "心坞栈管理"
      this.common.HeaderLocationThree.name = "心坞栈列表"
      getCoveShedList().then(res => {
        this.tableData = res.data;
      })
    },
    methods:{
      pageNumChange(pageNum){
        this.searchEasy(this.searchItems,pageNum);
      },
      search(searchItems){
        this.searchItems = searchItems;
        this.searchEasy(searchItems)
      },
      searchEasy(searchItems,pageNum){
        let coveShedClassify = null;
        let coveShedName = null;
        let coveShedUsername = null;
        let detailAddress = null;
        for (let i = 0;i<searchItems.length;i++){
          if (searchItems[i].value === "coveShedClassify"){
            coveShedClassify = searchItems[i].input
          }else if (searchItems[i].value === "coveShedName"){
            coveShedName = searchItems[i].input
          }else if (searchItems[i].value === "coveShedUsername"){
            coveShedUsername = searchItems[i].input
          }else if (searchItems[i].value === "detailAddress"){
            detailAddress = searchItems[i].input
          }
        }
        getCoveShedList(coveShedClassify,coveShedName,coveShedUsername,detailAddress,pageNum).then(res => {
          this.tableData = res.data
        })
      },
      keyup(){
        this.searchEasy(this.searchItems);
      },
      del(id){
        delByCoveShedId(id).then(res => {
            this.searchEasy(this.searchItems);
          }
        )
      },
      addMerchants(){
        this.$router.push("insert/")
      }
    }
  }
</script>

<style scoped>

</style>
